export enum DateSelectionType {
  None,
  Today = 1,
  ThreeDays = 2,
  OneWeek = 3,
  OneMonth = 4,
  Range = 5,
}
